export const returnPackPrice = (pack) => {
  let totalPricePackItemsNoDiscount = 0;
  let totalDicount = 0;
  pack.items.forEach((item) => {
    if (item?.discountAllocations[0]) {
      // Sum each discount value
      totalDicount += Number(
        item.discountAllocations[0].allocatedAmount.amount
      );
    }
    if (item?.variant?.priceV2?.amount) {
      // Sum each item price (multiply by quantity)
      totalPricePackItemsNoDiscount +=
        Number(item.variant.priceV2.amount) * item.quantity;
    }
  });
  const totalPricePackItemsWithDiscount =
    totalPricePackItemsNoDiscount - totalDicount;
  return {
    roundedTotalPricePackItemsWithDiscount: totalPricePackItemsWithDiscount
      .toFixed(2)
      .toString(),
    roundedTotalPricePackItemsNoDiscount: totalPricePackItemsNoDiscount
      .toFixed(2)
      .toString(),
  };
};
